import { MaestroVersion } from '@automata/api/apiSchemas';

export const getVersionCompatibleName = (version: MaestroVersion): string =>
  `${version.name}${!version.compatible ? ' (incompatible)' : ''}`;
